import { connect } from 'react-redux';
import type { AppState } from 'state/state.model';
import * as TradeAllocationSelectors from 'state/tradeAllocationForm/tradeAllocationForm.selector';

interface OwnProps {
  tabId: string;
}

interface StateProps {
  message: string;
}

export type ErrorStatusProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  return {
    message: TradeAllocationSelectors.getApplyError(state, tabId)!.message,
  };
};

export const connectErrorStatus = connect(mapStateToProps);
